import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import axios from  'axios';
import store from '../../../store';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { creatItemBuffSub, getInfoTiktok, getConfigMoDong } from '../../../actions/buffsubTiktok';
import parse from 'html-react-parser';
import Swal from 'sweetalert2';
import ServicesDescription from "../ServicesDescription";
import { isMobile } from 'react-device-detect';

class Taotientrinh extends Component {
	componentDidMount() {
        this.props.getConfigMoDong('tiktokbuff_follow');
	};
	
	state = {
		showDescription: isMobile? false : true
	}
	
	searchIdTiktok = (e) => {
		let valueChange = e.target.value;
		let link = valueChange;
		let dataForm = this.props.buffsub.formData;
		let checkerr = 0;
		var loaigetinfo = dataForm.loaiseeding;
		if (dataForm.loaiseeding === 'follow' || dataForm.loaiseeding === 'follow_sv2' || dataForm.loaiseeding === 'follow_sv3' || dataForm.loaiseeding === 'follow_sv4' || dataForm.loaiseeding === 'follow_sv5') {
			// if (valueChange.indexOf('tiktok.com/@') > -1) {
				// valueChange = valueChange.slice(valueChange.indexOf('tiktok.com/@'));
				// valueChange = valueChange.slice(valueChange.indexOf('@') + 1);
			// }
			var matches = valueChange.match(/video\/+[0-9]+/g);
			if (matches != null) {
				valueChange = matches[0].replace("video/", "");
				loaigetinfo = 'liketosub';
				if (dataForm.loaiseeding === 'follow' || dataForm.loaiseeding === 'follow_sv4' || dataForm.loaiseeding === 'follow_sv5') {
					loaigetinfo = 'liketosub_viet';
				}
			} else {
				// // valueChange='';
				// if (valueChange !== '' && isNaN(valueChange)) {
					// Swal.fire({
						// icon: 'error',
						// html: 'Không lấy được ID TikTok'
					// });
				// }
				var matches = valueChange.match(/@+(.*\?|.*)/g);
				if (matches != null) {
					valueChange = matches[0].replace(/[@//?]/g, "");
				} else {
					// checkerr++;
					// // valueChange='';
					// if (valueChange !== '') {
						// Swal.fire({
							// icon: 'error',
							// html: 'Không lấy được ID TikTok'
						// });
					// }
				}
			}
		} else if (dataForm.loaiseeding === 'comment' || dataForm.loaiseeding === 'like' || dataForm.loaiseeding === 'view') {
			// if (valueChange.indexOf('tiktok.com/@') > -1) {
				// if (valueChange.indexOf('video/') > -1) {
					// valueChange = valueChange.slice(valueChange.indexOf('video/') + 6);
				// } else {
					// checkerr++;
					// valueChange='';
					// alert('không lấy dược id');
				// }
			// }
			var matches = valueChange.match(/video\/+[0-9]+/g);
			if (matches != null) {
				valueChange = matches[0].replace("video/", "");
			} else {
				// // valueChange='';
				// if (valueChange !== '' && isNaN(valueChange)) {
					// Swal.fire({
						// icon: 'error',
						// html: 'Không lấy được ID TikTok'
					// });
				// }
			}
		}
		
		if (checkerr === 0 && valueChange !== '') {
			this.props.getInfoTiktok(loaigetinfo, valueChange);
		}
		
		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: e.target.name, value: valueChange}
		});

		if (checkerr === 0) {
			store.dispatch({
				type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
				payload: {name: 'link', value: link}
			});
		}
	}

	handleChangeDateStart = date => {
	    let dataFormOld = this.props.buffsub.formData;

		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: 'EndDatebh', value: this.addDays(date, 7)}
		});
		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: 'startDatebh', value: date}
		});
	}

	handleChangeDateEnd = date => {
	    let dataFormOld = this.props.buffsub.formData;

		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: 'EndDatebh', value: date}
		});
	}

	addDays = (date, days) => {
	  	var result = new Date(date);
	  	result.setDate(result.getDate() + days);
	  	return result;
	}

	onChangeForm = (e, checknumber = 0) => {
		let valueChange = e.target.value;
		if (checknumber === 1 && e.target.name === 'sltang') {
			if (valueChange.trim() !== '') {
				valueChange = Math.abs(parseInt(valueChange));
				if (isNaN(valueChange)) {
					valueChange = '';
				}
			}
		}
		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: e.target.name, value: valueChange}
		});
	}

	onChangeLoaiSeeding = (e) => {
		let valueChange = e.target.value;
		let dataForm = this.props.buffsub.formData;
		let dataPriceAll = this.props.buffsub.datapricebuffsub;
		let getStPriceEnd = this.props.buffsub.datapricebuffsub[valueChange].prices_web;
		if (dataForm.baohanh == 1) {
			getStPriceEnd = this.props.buffsub.datapricebuffsub[valueChange].min_bh_web;
		}
		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: 'giatien', value: getStPriceEnd}
		});

		let sltang_rt = 10;
		if (valueChange === 'comment') {
			sltang_rt = 0;
		}
		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: 'sltang', value: sltang_rt}
		});

		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: e.target.name, value: valueChange}
		});
	}

	onChangeBh = (e, checknumber = 0) => {
		let valueChange = e.target.value;
		if (checknumber === 1) {
			if (valueChange.trim() !== '') {
				valueChange = Math.abs(parseInt(valueChange));
				if (isNaN(valueChange)) {
					valueChange = '';
				}
			}
		}
		let dataForm = this.props.buffsub.formData;
		let dataPriceAll = this.props.buffsub.datapricebuffsub;
		let getStPriceEnd = this.props.buffsub.datapricebuffsub[dataForm.loaiseeding].prices_web;

		if (valueChange == 1) {
			getStPriceEnd = this.props.buffsub.datapricebuffsub[dataForm.loaiseeding].min_bh_web;
		}

		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: 'giatien', value: getStPriceEnd}
		});

		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: e.target.name, value: valueChange}
		});
	}

	getSltangComment = (e) => {
		let el = e.target;
		let countEnd = el.value.split("\n").length;
		if (el.value.trim() === '') {
			countEnd = 0;
		}

		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: 'sltang', value: countEnd}
		});
		store.dispatch({
			type: 'CHANGE_DATA_FORM_BUFF_SUB_TIKTOK',
			payload: {name: 'list_messages', value: el.value.split("\n")}
		});
	}

	onClickShowDescription = (data) => {
		this.setState({
			showDescription: data
		});
	}
	
 	render() {
 		const {formData, tiktokbufffollow_sv1_mo_dong, tiktokbufffollow_sv2_mo_dong, tiktokbufffollow_sv3_mo_dong, tiktokbufffollow_sv4_mo_dong, tiktokbufffollow_sv5_mo_dong} = this.props.buffsub;
		var info = '';
		if ((formData.loaiseeding === 'follow' || formData.loaiseeding === 'follow_sv2' || formData.loaiseeding === 'follow_sv3' || formData.loaiseeding === 'follow_sv4' || formData.loaiseeding === 'follow_sv5') && formData.infoTiktok.userid_tiktok !== '') {
			info = parse('<img src="'+formData.infoTiktok.avatarMedium_tiktok+'" class="avatar-user" /> ' + formData.infoTiktok.uniqueId_tiktok + ' ( sub: ' + formData.infoTiktok.fans_tiktok + ')');
		}
		if ((formData.loaiseeding === 'comment' || formData.loaiseeding === 'like' || formData.loaiseeding === 'view') && formData.infoTiktok.userid_tiktok !== '') {
			let param_view = "";
			if (formData.loaiseeding === 'view') {
				if (typeof formData.infoTiktok.playCount !== 'undefined') {
					param_view += ' ( View: ' + formData.infoTiktok.playCount + ')';
				}
			} else if (formData.loaiseeding === 'comment') {
				if (typeof formData.infoTiktok.cmt_count !== 'undefined') {
					param_view += ' ( Comment: ' + formData.infoTiktok.cmt_count + ')';
				}
			} else {
				if (typeof formData.infoTiktok.like_tiktok !== 'undefined') {
					param_view += ' ( Like: ' + formData.infoTiktok.like_tiktok + ')';
				}
			}
			info = parse('<img src="'+formData.infoTiktok.avatarMedium_tiktok+'" class="avatar-user" /> ' + formData.infoTiktok.uniqueId_tiktok + param_view);
		}
		
		var listDataServicesInfo = {};
		try {
			if (localStorage.getItem("listDataServicesInfo") != null) {
				listDataServicesInfo = JSON.parse(localStorage.getItem("listDataServicesInfo"));
			} else {
				listDataServicesInfo = this.props.adminpage.listDataServicesInfo;
			}
		} catch(e) {
			listDataServicesInfo = {};
		}
		var html_haydoctranhmattien = '';
		var html_haydoctranhmattien_chinh = '';
		var html_haydoctranhmattien_sv = '';
		var html_follow_sv1 = '';
		var html_follow_sv2 = '';
		var html_follow_sv3 = '';
		var html_follow_sv4 = '';
		var html_follow_sv5 = '';
		if (typeof(listDataServicesInfo.tiktok_buff_follow_tab) !== 'undefined') {
			html_haydoctranhmattien = parse(listDataServicesInfo.tiktok_buff_follow_tab.ghichu);
			html_haydoctranhmattien_chinh = parse(listDataServicesInfo.tiktok_buff_follow_tab.ghichu_chinh);
		}
		if (typeof(listDataServicesInfo.tiktok_buff_follow_sv1) !== 'undefined') {
			html_follow_sv1 = parse(listDataServicesInfo.tiktok_buff_follow_sv1.ghichu_sv);
			if (formData.loaiseeding === "follow") {
				html_haydoctranhmattien_sv = parse(listDataServicesInfo.tiktok_buff_follow_sv1.ghichu);
			}
		}
		if (typeof(listDataServicesInfo.tiktok_buff_follow_sv2) !== 'undefined') {
			html_follow_sv2 = parse(listDataServicesInfo.tiktok_buff_follow_sv2.ghichu_sv);
			if (formData.loaiseeding === "follow_sv2") {
				html_haydoctranhmattien_sv = parse(listDataServicesInfo.tiktok_buff_follow_sv2.ghichu);
			}
		}
		if (typeof(listDataServicesInfo.tiktok_buff_follow_sv3) !== 'undefined') {
			html_follow_sv3 = parse(listDataServicesInfo.tiktok_buff_follow_sv3.ghichu_sv);
			if (formData.loaiseeding === "follow_sv3") {
				html_haydoctranhmattien_sv = parse(listDataServicesInfo.tiktok_buff_follow_sv3.ghichu);
			}
		}
		if (typeof(listDataServicesInfo.tiktok_buff_follow_sv4) !== 'undefined') {
			html_follow_sv4 = parse(listDataServicesInfo.tiktok_buff_follow_sv4.ghichu_sv);
			if (formData.loaiseeding === "follow_sv4") {
				html_haydoctranhmattien_sv = parse(listDataServicesInfo.tiktok_buff_follow_sv4.ghichu);
			}
		}
		if (typeof(listDataServicesInfo.tiktok_buff_follow_sv5) !== 'undefined') {
			html_follow_sv5 = parse(listDataServicesInfo.tiktok_buff_follow_sv5.ghichu_sv);
			if (formData.loaiseeding === "follow_sv5") {
				html_haydoctranhmattien_sv = parse(listDataServicesInfo.tiktok_buff_follow_sv5.ghichu);
			}
		}
		
 		return (
    		<Fragment>
    			<div className="row">
					<div className="col-md-4">
						<label className="mt-2">Link hoặc ID trang cá nhân:</label>
					</div>
					<div className="col-md-8">
						<div className="form-group">
                            <input onChange={(e) => {this.searchIdTiktok(e)}} value={formData.profile_user} name="profile_user" type="text" className="form-control"/>
							{info}
							<h6 style={{"marginTop":"5px", "marginBottom":"0px"}}><span className="text-danger">Hãy tắt chế độ tài khoản riêng tư (Bắt buộc)</span>: <a href="https://i.imgur.com/g5ebGqF.png" target="_blank" className="font-bold"> Tại đây</a></h6>
							<h6 style={{"marginTop":"5px", "marginBottom":"0px"}}>Hướng dẫn link tiktok: <a href="https://i.imgur.com/uoLshF4.png" target="_blank" className="font-bold"> Tại đây(1)</a> hoặc <a href="https://i.imgur.com/A22d32Q.png" target="_blank" className="font-bold"> Tại đây(2)</a></h6>
							{
								formData.loaiseeding === 'view' || formData.loaiseeding === 'comment' || formData.loaiseeding === 'like' ?
									<h6 style={{"marginTop":"5px","marginBottom":"0px"}}>Link chuẩn để buff like, cmt, view: <span className="text-danger"> https://www.tiktok.com/@username/video/id_video</span></h6>
								: ''
							}
							{
								formData.loaiseeding === 'follow' || formData.loaiseeding === 'follow_sv2' || formData.loaiseeding === 'follow_sv3' || formData.loaiseeding === 'follow_sv4' || formData.loaiseeding === 'follow_sv5' ?
									<h6 style={{"marginTop":"5px","marginBottom":"0px"}}>Link chuẩn để buff theo dõi: <span className="text-danger"> https://www.tiktok.com/@username</span> hoặc <span className="text-danger"> https://www.tiktok.com/@username/video/id_video</span></h6>
								: ''
							}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-4">
						<label className="mt-2">Loại Seeding cần tăng:</label>
					</div>
					<div className="col-sm-8">
						<div className="custom-control custom-radio custom-control-inline" style={{opacity: this.props.buffsub.datapricebuffsub['follow'].prices_web == 0 ? '0.3' : '1' }}>
							<input onChange={(e) => {this.onChangeLoaiSeeding(e)}} value="follow" type="radio" className="custom-control-input" id="loaiseeding_1" name="loaiseeding" checked={formData.loaiseeding === "follow"} disabled={this.props.buffsub.datapricebuffsub['follow'].prices_web == 0 ? 'disabled' : ''} />
							<label className="custom-control-label" htmlFor="loaiseeding_1" > SV1 {html_follow_sv1} <span className="badge badge-primary" style={{"fontSize": "0.92rem"}}>{this.props.buffsub.datapricebuffsub['follow'].prices_web} coin</span> {tiktokbufffollow_sv1_mo_dong == 1 ? <span className="text-success">(Đang mở)</span> : <span className="text-danger">(Đang đóng)</span> }</label>
						</div>
						<br/>
						<div className="custom-control custom-radio custom-control-inline" style={{opacity: this.props.buffsub.datapricebuffsub['follow_sv2'].prices_web == 0 ? '0.3' : '1' }}>
							<input onChange={(e) => {this.onChangeLoaiSeeding(e)}} value="follow_sv2" type="radio" className="custom-control-input" id="loaiseeding_2" name="loaiseeding" checked={formData.loaiseeding === "follow_sv2"} disabled={this.props.buffsub.datapricebuffsub['follow_sv2'].prices_web == 0 ? 'disabled' : ''} />
							<label className="custom-control-label" htmlFor="loaiseeding_2" > SV2 {html_follow_sv2} <span className="badge badge-primary" style={{"fontSize": "0.92rem"}}>{this.props.buffsub.datapricebuffsub['follow_sv2'].prices_web} coin</span> {tiktokbufffollow_sv2_mo_dong == 1 ? <span className="text-success">(Đang mở)</span> : <span className="text-danger">(Đang đóng)</span> }</label>
						</div>
						<br/>
						<div className="custom-control custom-radio custom-control-inline" style={{opacity: this.props.buffsub.datapricebuffsub['follow_sv3'].prices_web == 0 ? '0.3' : '1' }}>
							<input onChange={(e) => {this.onChangeLoaiSeeding(e)}} value="follow_sv3" type="radio" className="custom-control-input" id="loaiseeding_3" name="loaiseeding" checked={formData.loaiseeding === "follow_sv3"} disabled={this.props.buffsub.datapricebuffsub['follow_sv3'].prices_web == 0 ? 'disabled' : ''} />
							<label className="custom-control-label" htmlFor="loaiseeding_3" > SV3 {html_follow_sv3} <span className="badge badge-primary" style={{"fontSize": "0.92rem"}}>{this.props.buffsub.datapricebuffsub['follow_sv3'].prices_web} coin</span> {tiktokbufffollow_sv3_mo_dong == 1 ? <span className="text-success">(Đang mở)</span> : <span className="text-danger">(Đang đóng)</span> }</label>
						</div>
						<br/>
						<div className="custom-control custom-radio custom-control-inline" style={{opacity: this.props.buffsub.datapricebuffsub['follow_sv4'].prices_web == 0 ? '0.3' : '1' }}>
							<input onChange={(e) => {this.onChangeLoaiSeeding(e)}} value="follow_sv4" type="radio" className="custom-control-input" id="loaiseeding_4" name="loaiseeding" checked={formData.loaiseeding === "follow_sv4"} disabled={this.props.buffsub.datapricebuffsub['follow_sv4'].prices_web == 0 ? 'disabled' : ''} />
							<label className="custom-control-label" htmlFor="loaiseeding_4" > SV4 {html_follow_sv4} <span className="badge badge-primary" style={{"fontSize": "0.92rem"}}>{this.props.buffsub.datapricebuffsub['follow_sv4'].prices_web} coin</span> {tiktokbufffollow_sv4_mo_dong == 1 ? <span className="text-success">(Đang mở)</span> : <span className="text-danger">(Đang đóng)</span> }</label>
						</div>
						<br/>
						<div className="custom-control custom-radio custom-control-inline" style={{opacity: this.props.buffsub.datapricebuffsub['follow_sv5'].prices_web == 0 ? '0.3' : '1' }}>
							<input onChange={(e) => {this.onChangeLoaiSeeding(e)}} value="follow_sv5" type="radio" className="custom-control-input" id="loaiseeding_5" name="loaiseeding" checked={formData.loaiseeding === "follow_sv5"} disabled={this.props.buffsub.datapricebuffsub['follow_sv5'].prices_web == 0 ? 'disabled' : ''} />
							<label className="custom-control-label" htmlFor="loaiseeding_5" > SV5 {html_follow_sv5} <span className="badge badge-primary" style={{"fontSize": "0.92rem"}}>{this.props.buffsub.datapricebuffsub['follow_sv5'].prices_web} coin</span> {tiktokbufffollow_sv5_mo_dong == 1 ? <span className="text-success">(Đang mở)</span> : <span className="text-danger">(Đang đóng)</span> }</label>
						</div>
					</div>
				</div>
				
				{
					formData.loaiseeding === "follow" || formData.loaiseeding === "follow_sv4" ?
						<div className="row">
							<div className="col-md-4">
								<label className="mt-2">Chế độ bảo hành:</label>
							</div>
							<div className="col-md-8">
								<div className="form-group">
									<select onChange={(e) => {this.onChangeBh(e, 1)}} value={formData.baohanh.toString()} name="baohanh" className="form-control">
										<option value="0">Không bảo hành</option>
										<option value="1">Bảo hành (Bảo hành nếu tụt quá 10%)</option>
									</select>
								</div>
								<div style={{display: formData.baohanh === 1 ? 'block':'none'}} className="form-group">
									<div className="row">
										<div className="col-md-6">
											<p className="mb-0">Chọn ngày bắt đầu</p>
											<DatePicker className="form-control w-100"
											showTimeSelect minDate={new Date()}
											selected={formData.startDatebh}
											onChange={this.handleChangeDateStart} />
										</div>
										<div className="col-md-6">
											<p className="mb-0">Chọn ngày kết thúc</p>
											<DatePicker className="form-control"
											showTimeSelect minDate={formData.startDatebh}
											maxDate={this.addDays(formData.startDatebh, 7)}
											selected={formData.EndDatebh}
											onChange={this.handleChangeDateEnd} />
										</div>
									</div>
								</div>
							</div>
						</div>
					: ''
				}

				{
					formData.loaiseeding !== "comment" ?
						<div className="row mt-2">
							<div className="col-md-4">
								<label className="mt-2">Số lượng cần tăng:</label>
							</div>
							<div className="col-md-8">
								<div className="form-group">
									<input type="number" className="form-control" onChange={(e) => {this.onChangeForm(e, 1)}} name="sltang" value={formData.sltang}/>
								</div>
								<div className="card card-orange mt-2">
									<div className="card-body py-2">
										<h6 className="font-14 mb-0 text-danger font-bold">
											Lưu ý: Buff không bảo hành nên buff thừa 30 - 50% để đủ số lượng
										</h6>
									</div>
								</div>
							</div>
						</div>
					: ''
				}


				<div className="row mt-2">
					<div className="col-md-4">
						<label className="mt-2">Giá tiền mỗi tương tác:</label>
					</div>
					<div className="col-md-8">
						<div className="form-group">
							<input type="number" className="form-control" onChange={(e) => {this.onChangeForm(e, 1)}} name="giatien" value={formData.giatien}/>
						</div>
					</div>
				</div>

				{ formData.loaiseeding === 'comment' ?
						<div className="row mt-2">
							<div className="col-md-12">
								<div className="card card-orange mb-3">
									<div className="card-body py-3">
										<h6 className="font-14 mb-0 text-danger font-bold mt-2">Nghiêm cấm bình luận các nội dung có biểu tượng Icon.</h6>
										<h6 className="font-14 mb-0 text-danger font-bold mt-2">Nghiêm cấm bình luận những nội có cử chỉ, lời nói thô bạo, khiêu khích, trêu ghẹo, xúc phạm nhân phẩm, danh dự của Cá nhân hoặc Tổ chức.</h6>
										<h6 className="font-14 mb-0 text-danger font-bold mt-2">Nếu cố tình buff bạn sẽ bị trừ hết tiền và ban khỏi hệ thống api vĩnh viễn, và phải chịu hoàn toàn trách nhiệm trước pháp luật.</h6>
										<h6 className="font-14 mb-0 text-danger font-bold mt-2">Các ngôn từ bị cấm: dm|đm|đ m|d m|địt mẹ|dit me|lol|lừađảo|conchó|trảtiền|mấtdạy|lừa đảo|con chó|trả tiền|mất dạy|lua dao|con cho|tra tien|mat day</h6>
									</div>
								</div>

								<span className="font-13 ml-2">Nhập nội dung Comment (<label className="font-bold font-13">Mỗi dòng tương đương với 1 Comment</label>):</span>
								<span className="badge badge-primary text-white py-1">Số lượng: {formData.sltang}</span>

								<div className="form-group mt-2">
									<textarea rows="10" onChange={(e) => this.getSltangComment(e)} placeholder="Nhập nội dung seeding, mỗi dòng 1 nội dung được tính tiền là 1 lần seeding" className="form-control input-gray">
									</textarea>
								</div>
							</div>
						</div>
					: ''
				}

				<div className="row mt-2">
					<div className="col-md-4">
						<label className="mt-2">Ghi chú:</label>
					</div>
					<div className="col-md-8">
						<div className="form-group">
                            <textarea onChange={(e) => {this.onChangeForm(e)}} name="ghichu" value={formData.ghichu} className="form-control" rows="4" placeholder="Nhập nội dung ghi chú về tiến trình của bạn"></textarea>
                        </div>
					</div>
				</div>

				<button type="button" className="btn badge-primary-cus btn-rounded btn-show-description-cus" onClick={(e) => {this.onClickShowDescription(!this.state.showDescription)}}>
					{
						this.state.showDescription?
							<i className="fa fa-angle-up" style={{"marginRight": "5px"}} aria-hidden="true"></i>
						:
							<i className="fa fa-angle-down" style={{"marginRight": "5px"}} aria-hidden="true"></i>
					}
					Thông tin dịch vụ
				</button>
				
				<ServicesDescription allservicesinfo={listDataServicesInfo} server={formData.loaiseeding} tab="tiktok_buff_follow" giatien={formData.giatien} baohanh={formData.baohanh} showDescription={this.state.showDescription} />
				
				<div className="row mt-2" style={{"display": this.state.showDescription? "flex" : "none"}}>
				    <div className="col-md-12 bold" style={{"marginBottom": "10px"}}>
						<div className="card card-select-cus">
							<div className="card-body card-body-select-cus">
								<p className="mb-0 mt-3 text-wrap">
									<ul>
										<li>1 ID KHÔNG CÀI 2 ĐƠN CÙNG LÚC TRONG HỆ THỐNG ! ĐƠN CŨ XONG MỚI CÀI ĐƠN MỚI ! CỐ TÌNH CÀI BỊ HỤT SỐ LƯỢNG SẼ KHÔNG XỬ LÝ !</li>
										<li>Nếu ID đang chạy trên hệ thống mà bạn vẫn mua id đó cá hệ thống bên khác, nếu có tình trạng hụt số lượng giữa 2 bên thì sẽ không được xử lí!</li>
										{html_haydoctranhmattien}
										{html_haydoctranhmattien_chinh}
										{html_haydoctranhmattien_sv}
										<li>Nếu gặp lỗi hãy nhắn tin hỗ trợ phía bên phải góc màn hình hoặc vào mục liên hệ hỗ trợ để được hỗ trợ tốt nhất!</li>
									</ul>
								</p>
								<span className="badge badge-cus position-absolute-cus badge-top-left-cus badge-primary-cus badge-pill-cus"> HÃY ĐỌC ĐỂ TRÁNH MẤT TIỀN KHI SỬ DỤNG! </span>
							</div>
						</div>
				    </div>
				</div>
				<div className="row mt-4">
				    <div className="col-12 text-center bold">
				        <div className="card card-info">
				            <div className="card-body">
				                <h5 className="font-bold">Tổng: <span className="bold green"><span>{Math.round((formData.sltang * formData.giatien + Number.EPSILON) * 100) / 100}</span> Coin</span></h5>
				                <h6 className="mb-0">Bạn sẽ buff <span className="bold green">{formData.sltang} {formData.loaiseeding}</span> với giá <span className="green bold">{Math.round((formData.sltang * formData.giatien + Number.EPSILON) * 100) / 100}</span> Coin</h6>
				            </div>
				        </div>
				    </div>
				</div>

				<div className="row mt-4">
					<div className="col-md-12">
						<div className='form-group float-right w-100'>
							<button onClick={(e) => {this.props.creatItemBuffSub(formData)}} type="button" className="btn btn-hero-primary btn-rounded btn-block">
	                            Tạo tiến trình
	                        </button>
                        </div>
					</div>
				</div>
			</Fragment>
		);
  	}
}

const mapStateToProps = state => ({
	auth: state.auth,
	buffsub: state.tiktok_buffsub
});

export default connect(mapStateToProps, {creatItemBuffSub, getInfoTiktok, getConfigMoDong})(Taotientrinh);
